import { Injectable } from '@angular/core';
import { EmbateDto } from '@models/embate/clash-dto';
import { ResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { finalize, Observable } from 'rxjs';
import { BaseService } from '../base-service';
import { MetadataPutEnum } from '@models/enums/metadata-put-enum';
import { EspacoVagaDto } from './espaco-vaga.service';

@Injectable({
  providedIn: 'root',
})
export class SpaceRoundService extends BaseService {
  private readonly url = this.envUrl + '/v1/espacos-rodadas';

  constructor() {
    super();
  }

  criar(form: EspacoRodadaForm): Observable<EspacoRodadaDto> {
    return this.http.post<ResponseDto<EspacoRodadaDto>>(this.url, form).pipe(
      finalize(() => this.loadingService.deactivate()),
      extractResponse(),
    );
  }

  editar(form: EspacoRodadaForm): Observable<EspacoRodadaDto> {
    return this.http.put<ResponseDto<EspacoRodadaDto>>(this.url, form).pipe(
      extractResponse(),
      finalize(() => this.loadingService.deactivate()),
    );
  }

  buscarPorId(eprNrId: number): Observable<EspacoRodadaDto> {
    return this.http
      .get<ResponseDto<EspacoRodadaDto>>(`${this.url}/${eprNrId}`)
      .pipe(extractResponse());
  }

  deletar(eprNrId: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${eprNrId}`).pipe(
      finalize(() => this.loadingService.deactivate()),
    );
  }

  listarPorRodada(
    rodNrId: number,
    page = 0,
    size = 999,
  ): Observable<IPage<EspacoRodadaDto>> {
    return this.http
      .get<
        ResponseDto<IPage<EspacoRodadaDto>>
      >(`${this.url}/rodada/${rodNrId}?page=${page}&size=${size}`)
      .pipe(extractResponse());
  }

  distribuirEmbatesNosEspacos(eveNrId: number, comNrId: number): Observable<void> {
    return this.http
      .post<ResponseDto<void>>(`${this.url}/${eveNrId}/embates-espacos/${comNrId}`, null)
      .pipe(
        extractResponse(),
        finalize(() => this.loadingService.deactivate()),
      );
  }
}

export interface EspacoRodadaForm {
  entNrId: number;
  entTxMetadado: MetadataPutEnum;
  epcNrId: number;
  rodNrId: number;
  eprTmHorarioInicial: string;
  eprNrQuantidadeInscricoes?: number | null;
  eprBlQuadraPrioritaria: boolean;
}

export interface EspacoRodadaDto {
  eprNrId: number;
  epcNrId: number;
  areNrId: number;
  epcTxNome: string;
  areTxNome: string;
  rodNrId: number;
  eprTmHorarioInicial: string;
  eprNrQuantidadeInscricoes?: number | null;
  eprBlQuadraPrioritaria: boolean;
  eprListEspacoVaga: EspacoVagaDto[];
}
